import { Typography } from "@mui/material"
import { Bar, BarChart, CartesianGrid, Cell, ReferenceLine, ResponsiveContainer, XAxis, YAxis } from "recharts"

export const GraficoPadrao = ({ mediaAgrupadorList, nomeAgrupador, fullName, meta }) => {
    const xField = "groupNameShow";
    const yField = "media";
    const barRadius = 10

    // numeros em cima das barras dos graficos
    const BarCustomizedLabel = (props) => {
        const { x, y, width, value } = props;
        return <text
            x={x + (width / 2)}
            y={y}
            dy={16}

            fontSize='16'
            fontWeight={600}
            fontFamily='sans-serif'
            textAnchor="middle">{value}</text>

    }

    const findMaiorNumero = () => {
        const f = parseFloat
        if (!mediaAgrupadorList || !mediaAgrupadorList.length || mediaAgrupadorList.length === 0) return null

        let maior = f(mediaAgrupadorList[0].media)
        for (let i = 1; i < mediaAgrupadorList.length; i++)
            if (f(mediaAgrupadorList[i].media) > f(maior))
                maior = f(mediaAgrupadorList[i].media)

        return maior
    }

    const barCustomShape = (props) => {
        const { x, y, width, height, color } = props;

        return (
            <g>
                <path
                    d={`
                        M${x},${y}
                        L${x},${y + height}
                        L${x + width},${y + height}
                        L${x + width},${y + barRadius}
                        Q${x + width},${y},${x + width - barRadius},${y}
                        L${x + barRadius},${y}
                        Q${x},${y},${x},${y + barRadius}
                        Z
                    `}
                    fill={color || '#cacacc'}
                />
            </g>
        );
    };

    return (
        <>
            <ResponsiveContainer width={'100%'} height={300} /*className="rounded-bar-chart"*/>
                <BarChart width={400} height={300} data={mediaAgrupadorList} margin={{ right: 20, }} fontFamily='sans-serif'>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey={xField} />
                    <YAxis domain={[0, Math.round((findMaiorNumero() * 1.05))]} />
                    <Bar
                        dataKey={yField}
                        shape={barCustomShape} // cor e formato do gráfico é definido nessa função

                        // numeros em cima das barras dos graficos
                        label={<BarCustomizedLabel />}
                    >
                        {mediaAgrupadorList.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Bar>
                    {meta && <ReferenceLine ifOverflow="extendDomain" y={parseFloat(meta)} stroke="blue" />}
                </BarChart>
            </ResponsiveContainer>

            <Typography sx={{ textAlign: 'center', fontFamily: 'sans-serif' }} variant={'subtitle1'}>
                Meta: {meta}
            </Typography>

            <Typography sx={{ textAlign: 'center', fontFamily: 'sans-serif' }} variant={'h6'}>{fullName}</Typography>
            <Typography sx={{ textAlign: 'center', fontFamily: 'sans-serif' }} variant={'caption'}>por {nomeAgrupador}</Typography>
        </>
    )
}